var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    {
      staticClass: "faqq__question",
      class: { "faqq__question--active": _vm.active },
    },
    [
      _c(
        "h5",
        {
          staticClass: "faqq__question-title",
          class: _vm.question.post_name,
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.toggle.apply(null, arguments)
            },
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.question.post_title) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.active,
              expression: "active",
            },
          ],
          staticClass: "faqq__question-text",
        },
        [_vm._v("\n    " + _vm._s(_vm.question.post_content) + "\n  ")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/FaqQuestion.vue